export default __webpack_public_path__ + "2250c1a.png";